module.exports = __webpack_public_path__ + "static/media/webConference.0bc8e43b.svg";